import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import { useEffect, useState } from 'react';
import { setConversationRating } from '../../../redux/slices/communication';

export function InteralRating() {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const rating = [
    { name: 'bad', class: 'fa-duotone fa-face-frown', value: 0 },
    { name: 'neutral', class: 'fa-duotone fa-face-expressionless', value: 1 },
    { name: 'good', class: 'fa-duotone fa-face-smile-beam', value: 2 }
  ];
  const {
    data: { activeConversation }
  } = useSelector((state) => state.communication);
  const [activateRating, setActivateRating] = useState(
    activeConversation.internal_rating
  );
  useEffect(() => {
    setActivateRating(activeConversation.internal_rating);
  }, [activeConversation]);

  return (
    <div className="card m-2 p-4 shadow w-100">
      <b className="text-muted m-0 mb-2 p-0 fs-6 fw-bold">
        {t('communication.general_info.internal_rating')}
      </b>
      <div className="mt-1" />
      <div className="d-flex justify-content-between mx-4">
        {rating.map((rate, index) => (
          <div key={index} className="d-flex flex-column align-items-center">
            <i
              className={`${rate.class} fs-1 cursor-pointer`}
              style={{
                color:
                  activateRating === rate.value
                    ? '#ffc107'
                    : 'var(--bs-gray-500)'
              }}
              onClick={() => {
                setActivateRating(rate.value);
                dispatch(
                  setConversationRating(activeConversation.uuid, rate.value)
                );
              }}
            ></i>
          </div>
        ))}
      </div>
      <div className="mt-3" />
      <div className="d-flex justify-content-end">
        <span
          className="text-muted fs-7 fw-bold cursor-pointer"
          onClick={() => {
            setActivateRating(null);
            dispatch(setConversationRating(activeConversation.uuid, null));
          }}
        >
          {t('communication.general_info.remove_rating')}
        </span>
      </div>
    </div>
  );
}
